<template>
  <main>
    <v-container>
      <h1>
        <v-icon
          v-if="!isEdit"
          class="teams-icon icon-user"
          color="success"
          medium
          >mdi-basecamp</v-icon
        >
        <v-icon v-else class="teams-icon icon-user" color="success" medium
          >mdi-pencil</v-icon
        >
        <span v-if="isEdit">Edit Camp</span>
        <span v-else>New Camp</span>
      </h1>
      <v-row>
        <v-col lg="10" class="mx-auto">
          <v-alert
            v-if="globalServerErrors !== null"
            dense
            outlined
            type="error"
          >
            <p
              class="mb-0"
              v-for="globalErr in globalServerErrors"
              :key="globalErr"
            >
              {{ globalErr[0] }}
            </p>
          </v-alert>
          <formWrapper :validator="$v.form">
            <form @submit.prevent="handleSave" class="form-box">
              <basic-info-form :v="$v" :form="form" :isEdit="isEdit" />
              <hr class="my-12" />
              <age-groups
                :v="$v"
                :form="form"
                :groups="groups"
                :classifications="classifications"
                :isEdit="isEdit"
                @handle_table_data="handleTableData"
                @handle_reset_data="reset"
              />
              <hr class="my-12" />
              <camp-prices
                :form="form"
                :discounts="discounts"
                :isEdit="isEdit"
                :discoutsItems="discoutsItems"
                @handle_reset_discount="handleResetDiscount"
                @handle_discounts_added="handleDiscountsAdded"
              />
              <hr class="my-12" />
              <majors
                @handle_reset_majors="resetMajors"
                @handle_majors_data="handleMajorsData"
                :majors="majors"
                :isEdit="isEdit"
                :classifications="classifications"
              />
              <section v-if="!isEdit" class="transparent-field mt-8">
                <v-switch
                  v-model="form.show_majors"
                  inset
                  label="Show Majors"
                  color="success"
                ></v-switch>
              </section>
              <hr class="my-12" />
              <bus-stops
                :buses="buses"
                :busItems="busItems"
                :isEdit="isEdit"
                @handle_bus_data="handleBusData"
                @handle_reset_bus_data="resetBusData"
                :form="form"
              />
              <hr class="my-12" />
              <camp-description :form="form" />
              <hr class="my-12" />
              <files-upload :form="form" :isEdit="isEdit" />
              <hr class="my-12" />
              <family-camps
                v-if="form.type.id === 30 || is_family === true"
                :pricelists="pricelists"
                :pricelistItems="pricelistItems"
                :isEdit="isEdit"
                @handle_pricelist_data="handlePricelistData"
                @handle_reset_pricelist="handleResetPricelist"
                :family="family"
              />

              <section class="transparent-field">
                <v-switch
                  v-model="form.available"
                  inset
                  label="Show Camp"
                  color="success"
                ></v-switch>
              </section>
              <section class="transparent-field">
                <v-switch
                  v-model="form.orange_admin"
                  inset
                  class="mt-0"
                  label="Orange Admin"
                  color="success"
                ></v-switch>
              </section>
              <section class="transparent-field">
                <v-switch
                  v-model="form.can_register"
                  inset
                  class="mt-0"
                  label="Can Register"
                  color="success"
                ></v-switch>
              </section>
              <v-btn
                class="success text-capitalize"
                large
                type="submit"
                width="30%"
                :disabled="$v.form.$invalid"
              >
                <span>Save</span></v-btn
              >
            </form>
          </formWrapper>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
import { required, maxLength, minLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        cashondelivery_payment: false,
        name: "",
        theme: "",
        short_name: "",
        type: {
          id: "",
          name: ""
        },
        sub_type: {
          id: "",
          name: ""
        },
        registration_start_date: { date: "" },
        registration_end_date: { date: "" },
        location: {
          id: "",
          location: ""
        },
        currency: {
          id: "",
          location: ""
        },
        start_date: { date: "" },
        end_date: { date: "" },
        no_of_days: null,
        price: 0
      },
      // Age Group
      groups: {
        classification: null,
        min_grade: {
          name: "",
          id: ""
        },
        max_grade: {
          name: "",
          id: ""
        },
        min_age: 0,
        max_age: 0,
        teams: null,
        teams_per_group: null,
        spots_per_team: 0
      },
      majors: {
        id: null,
        classification: null,
        boys_capacity: null,
        girls_capacity: null
      },
      items: [],
      busItems: [],
      majorsItems: [],
      pricelistItems: [],
      discounts: {
        id: null,
        value: null,
        value_type: null,
        expiry_date: { date: "" }
      },
      discoutsItems: [],
      buses: {
        id: null,
        capacity: null
      },
      family: {
        family_relations: []
      },
      pricelists: {
        from: null,
        to: null,
        price: null
      },
      isEdit: false,
      is_family: false,
      classifications: [],
      globalServerErrors: null
    };
  },
  components: {
    BasicInfoForm: () => import("./components/BasicInfo"),
    AgeGroups: () => import("./components/AgeGroups"),
    CampPrices: () => import("./components/CampPrices"),
    CampDescription: () => import("./components/Description"),
    Majors: () => import("./components/Majors"),
    BusStops: () => import("./components/BusStops"),
    FamilyCamps: () => import("./components/FamilyCamps"),
    FilesUpload: () => import("./components/Files")
  },
  methods: {
    reset() {
      this.groups = {
        classification: null,
        min_grade: {
          name: null,
          id: null
        },
        max_grade: {
          name: null,
          id: null
        },
        min_age: 0,
        max_age: 0,
        teams: null,
        teams_per_group: null,
        spots_per_team: 0
      };
    },
    resetBusData() {
      this.buses = {
        bus_location: null,
        capacity: null
      };
    },
    resetMajors() {
      this.majors = {
        id: null,
        classification: null,
        boys_capacity: null,
        girls_capacity: null
      };
    },
    handleResetPricelist() {
      this.pricelists = {
        from: null,
        to: null,
        price: null
      };
    },
    handleResetDiscount() {
      this.discounts = {
        discount: null,
        value: null,
        value_type: null,
        expiry_date: { date: "" }
      };
    },
    handleDiscountsAdded(discountsValues) {
      this.discoutsItems = discountsValues;
    },
    // Age Groups
    handleTableData(data) {
      this.items = data;
    },
    // Bus Stops
    handleBusData(busesData) {
      this.busItems = busesData;
    },
    // Bus Stops
    handleMajorsData(majorsData) {
      this.majorsItems = majorsData;
    },
    // Price List
    handlePricelistData(pricelistData) {
      this.pricelistItems = pricelistData;
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    },
    handleSave() {
      this.$route.params.id ? this.handleEdit() : this.createCamp();
      // this.createCamp();
    },
    handleEdit() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      this.form.registration_start_date = {
        date: this.$moment(this.form.registration_start_date.date).format(
          dateFormat
        )
      };
      this.form.registration_end_date = {
        date: this.$moment(this.form.registration_end_date.date).format(
          dateFormat
        )
      };
      this.form.start_date = {
        date: this.$moment(this.form.start_date.date).format(dateFormat)
      };
      this.form.end_date = {
        date: this.$moment(this.form.end_date.date).format(dateFormat)
      };
      // Basic Info
      Object.keys(this.form).forEach(formItem => {
        if (
          formItem === "type" ||
          formItem === "location" ||
          formItem === "sub_type" ||
          formItem === "currency"
        ) {
          formData.append(formItem, this.form[formItem].id);
        } else if (
          formItem === "pricelists" ||
          formItem === "discounts" ||
          formItem === "bus_locations" ||
          formItem === "relations" ||
          formItem === "show_majors"
        ) {
          return;
        } else if (
          formItem === "registration_start_date" ||
          formItem === "registration_end_date" ||
          formItem === "start_date" ||
          formItem === "end_date"
        ) {
          formData.append(formItem, this.form[formItem].date);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      // Bus Stops
      if (this.busItems.length > 0) {
        this.busItems.forEach((busItem, index) => {
          Object.keys(busItem).forEach(bus_location => {
            if (bus_location === "name" || bus_location === "bus_stops") {
              return;
            }
            formData.append(
              `bus_locations[${index}][${bus_location}]`,
              busItem[bus_location]
            );
          });
        });
      } else if (this.busItems.length == 0) {
        formData.append(`bus_locations`, "");
        // formData.append(`has_bus`, false);
      }
      if (this.form.type.id === 30) {
        // Family Relatioships
        if (this.family.family_relations.length) {
          Object.keys(this.family.family_relations).forEach(
            (family_relation, index) => {
              formData.append(
                `family_relations[${index}]`,
                this.family.family_relations[family_relation].id
              );
            }
          );
        }
        // Family Price List
        this.pricelistItems.forEach((pricelistItem, index) => {
          Object.keys(pricelistItem).forEach(pricelist => {
            formData.append(
              `pricelists[${index}][${pricelist}]`,
              pricelistItem[pricelist]
            );
          });
        });
      }
      if (this.discoutsItems.length > 0) {
        this.discoutsItems.forEach((discountItem, index) => {
          Object.keys(discountItem).forEach(discountArea => {
            if (discountArea === "name" || discountArea === "discount") {
              return;
            }
            if (discountArea === "expiry_date") {
              if (discountItem[discountArea] != null) {
                if (
                  discountItem[discountArea].date != "" &&
                  discountItem[discountArea].date != null
                ) {
                  formData.append(
                    `discounts[${index}][${discountArea}]`,
                    this.$moment(discountItem[discountArea].date).format(
                      dateFormat
                    )
                  );
                }
              } else {
                formData.append(`discounts[${index}][${discountArea}]`, "");
              }
            } else {
              formData.append(
                `discounts[${index}][${discountArea}]`,
                discountItem[discountArea]
              );
            }
          });
        });
      }
      formData.append("_method", "put");
      UpdateData({
        reqName: `camps`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          history.go(-1);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    createCamp() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      this.form.registration_start_date = {
        date: this.$moment(this.form.registration_start_date.date).format(
          dateFormat
        )
      };

      this.form.registration_end_date = {
        date: this.$moment(this.form.registration_end_date.date).format(
          dateFormat
        )
      };
      this.form.start_date = {
        date: this.$moment(this.form.start_date.date).format(dateFormat)
      };
      this.form.end_date = {
        date: this.$moment(this.form.end_date.date).format(dateFormat)
      };
      this.discounts.expiry_date = this.$moment(
        this.discounts.expiry_date.date
      ).format("M/DD/YYYY");
      // Basic Info
      Object.keys(this.form).forEach(formItem => {
        if (
          formItem === "type" ||
          formItem === "sub_type" ||
          formItem === "location" ||
          formItem === "currency"
        ) {
          formData.append(formItem, this.form[formItem].id);
        } else if (
          formItem === "registration_start_date" ||
          formItem === "registration_end_date" ||
          formItem === "start_date" ||
          formItem === "end_date"
        ) {
          formData.append(formItem, this.form[formItem].date);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      // Age Groups
      if (this.items.length > 0) {
        this.items.forEach((item, index) => {
          Object.keys(item).forEach(group => {
            if (group === "min_grade" || group === "max_grade") {
              formData.append(`groups[${index}][${group}]`, item[group].id);
            } else {
              formData.append(`groups[${index}][${group}]`, item[group]);
            }
            // formData.append(`groups[${index}][${group}]`, item[group]);
          });
        });
      }
      // Bus Stops
      if (this.busItems.length > 0) {
        this.busItems.forEach((busItem, index) => {
          Object.keys(busItem).forEach(bus_location => {
            if (bus_location === "name" || bus_location === "bus_stops") {
              return;
            }
            formData.append(
              `bus_locations[${index}][${bus_location}]`,
              busItem[bus_location]
            );
          });
        });
      }
      if (this.majorsItems.length > 0) {
        this.majorsItems.forEach((majorItem, index) => {
          Object.keys(majorItem).forEach(majorData => {
            if (majorData === "name" || majorData === "major_name") {
              return;
            }
            formData.append(
              `majors[${index}][${majorData}]`,
              majorItem[majorData]
            );
          });
        });
      }
      if (this.discoutsItems.length > 0) {
        this.discoutsItems.forEach((discountItem, index) => {
          Object.keys(discountItem).forEach(discountArea => {
            if (discountArea === "name" || discountArea === "discount") {
              return;
            }
            if (discountArea === "expiry_date") {
              if (discountItem[discountArea] != null) {
                if (
                  discountItem[discountArea].date != "" &&
                  discountItem[discountArea].date != null
                ) {
                  formData.append(
                    `discounts[${index}][${discountArea}]`,
                    this.$moment(discountItem[discountArea].date).format(
                      dateFormat
                    )
                  );
                }
              } else {
                formData.append(`discounts[${index}][${discountArea}]`, "");
              }
            } else {
              formData.append(
                `discounts[${index}][${discountArea}]`,
                discountItem[discountArea]
              );
            }
          });
        });
      }
      if (this.form.type.id === 30) {
        // Family Relatioships
        if (this.family.family_relations.length) {
          Object.keys(this.family.family_relations).forEach(
            (family_relation, index) => {
              formData.append(
                `family_relations[${index}]`,
                this.family.family_relations[family_relation].id
              );
            }
          );
        }
        // Family Price List
        this.pricelistItems.forEach((pricelistItem, index) => {
          Object.keys(pricelistItem).forEach(pricelist => {
            formData.append(
              `pricelists[${index}][${pricelist}]`,
              pricelistItem[pricelist]
            );
          });
        });
      }
      StoreData({
        reqName: `camps`,
        data: formData
      })
        .then(res => {
          this.$router.push("/camps");
          console.log(res);
          // this.available_teams.push(res.data.camp_team);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    handleEditCamp(id) {
      // this.isEdit = true;
      ShowData({
        reqName: "camps",
        id
      })
        .then(res => {
          const { camp } = res.data;
          console.log(camp);
          this.form = { ...camp };
          // this.form.sub_type = { ...camp.type };

          this.form.sub_type = camp.type.sub_types.filter(
            item => item.selected
          )[0];
          if (camp.has_bus_locations === true) {
            this.form.has_bus = camp.has_bus_locations;
          }
          this.discoutsItems = camp.discounts;
          this.busItems = camp.bus_locations;
          this.pricelistItems = camp.pricelists;
          this.is_family = { ...camp.is_family };
          this.family.family_relations = [...camp.relations.map(el => el)];
          if (camp.description == null) {
            this.form.description = "";
          }
          if (camp.comments == null) {
            this.form.comments = "";
          }
          if (camp.has_bus_locations_text == null) {
            this.form.has_bus_locations_text = "";
          }
          if (camp.has_early_check_in_text == null) {
            this.form.has_early_check_in_text = "";
          }
          if (camp.has_late_check_out_text == null) {
            this.form.has_late_check_out_text = "";
          }
          if (camp.has_meals_text == null) {
            this.form.has_meals_text = "";
          }
          if (camp.has_photo_text == null) {
            this.form.has_photo_text = "";
          }
          if (camp.has_special_needs_text == null) {
            this.form.has_special_needs_text = "";
          }
          // if (camp.abroad_terms_and_conditions == null) {
          //   this.form.abroad_terms_and_conditions = "";
          // }
          // if (camp.deposit_value == null) {
          //   this.form.deposit_value = "";
          // }
        })
        .catch(() => {});
    },
    indexClassifications() {
      IndexData({ reqName: "classifications" })
        .then(res => {
          const { data } = res.data;
          this.classifications = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  created() {
    this.editCreateBoolean();
    // if (this.isEdit === true) {
    //   this.handleEditCamp();
    // }
    this.indexClassifications();
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "editCamp") {
          this.$nextTick(() => {
            this.handleEditCamp(route.params.id);
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      short_name: {
        required
      },
      theme: {
        required
      },
      type: {
        required
      },
      sub_type: {
        required
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      registration_start_date: {
        required
      },
      registration_end_date: {
        required
      },
      no_of_days: {
        required
      },
      location: {
        required
      },
      description: {
        maxLength: maxLength(20000)
      },
      comments: {
        maxLength: maxLength(20000)
      },
      visa_name: {
        minLength: minLength(3)
      }
    },
    groups: {
      classification: {
        required
      },
      min_grade: {
        required
      },
      max_grade: {
        required
      },
      teams: {
        required
      },
      teams_per_group: {
        required
      }
    }
  }
};
</script>
